import $ from 'jquery';

import './js/helpers';
import { bodyUtils, pageLoadUtils, textUtils, windowScrollUtils } from './js/body';
import { modalUtils } from './js/modal';
import { videoUtils } from './js/video';
import { formUtils } from './js/forms';
import { waveMaskUtils } from './js/wave-mask';

let windowWidth = $(window).width();

$(function() {
  bodyUtils();
  formUtils();
  textUtils();
  modalUtils();
  videoUtils();
  pageLoadUtils();
  waveMaskUtils();
});

$(window).on('load', function() {
  windowScrollUtils();
});

$(window).on('scroll', function() {
  windowScrollUtils();
});

$(window).on('resize', function() {
  windowWidth = $(window).width();
});
